// extracted by mini-css-extract-plugin
export default {"tableContainer":"PromotionTable_tableContainer__TJ9Ue","content":"PromotionTable_content__i6dhV","icon":"PromotionTable_icon__lh4bL"};